// extracted by mini-css-extract-plugin
module.exports = {"CandidateFAQ":"_2_qoUJGU","content":"_3kG6STWC","question":"_3PRUSqfS","answer":"_31A4l1Uk","supportText":"_1Tikw0bH","bold":"mA5uEaQ5"};
    if(module.hot) {
      // 1754514921652
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  